import Hello from './Hello.jsx'
import './Hello.less'

export default Hello
